var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1.27637 7.0498c-.552288 0-1.000003.44772-1.000003 1 0 .55229.447715 1 1.000003 1zm22.63423 1.70711c.3906-.39052.3906-1.02369 0-1.41421l-6.3639-6.363961c-.3905-.390525-1.0237-.390525-1.4142 0-.3906.390521-.3906 1.023691 0 1.414211l5.6568 5.65686-5.6568 5.65689c-.3906.3905-.3906 1.0236 0 1.4142.3905.3905 1.0237.3905 1.4142 0zm-22.63423.29289 21.92713.00001v-2l-21.92713-.00001z"}));
}

ArrowInline.defaultProps = {"height":"16","viewBox":"0 0 25 16","width":"25"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
